var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "position-relative" }, [
    _vm.isLoggedIn
      ? _c("div", { class: { dropdown: !_vm.hideDropdown } }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              class: { "dropdown-toggle": !_vm.hideDropdown },
              attrs: {
                href: "#",
                id: "accountMenuList",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window",
              },
            },
            [
              !_vm.noIcons
                ? _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "31.193",
                        height: "31.193",
                        viewBox: "0 0 31.193 31.193",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "data-name": "account",
                          d: "M21.6,26.216c8.614,0,15.6,3.258,15.6,7.278v5.2H6v-5.2C6,29.474,12.983,26.216,21.6,26.216ZM21.6,7.5a7.278,7.278,0,1,1-7.278,7.278A7.278,7.278,0,0,1,21.6,7.5Z",
                          transform: "translate(-6 -7.5)",
                          fill: "#fff",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.smallStyle
                ? _c("span", { staticClass: "d-none d-sm-inline" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Ceres::Template.loginHello", {
                          username: _vm.username,
                        })
                      )
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          !_vm.hideDropdown
            ? _c("div", { staticClass: "dropdown-menu small m-0 p-0 mw-100" }, [
                _c(
                  "div",
                  {
                    staticClass: "list-group",
                    attrs: { "aria-labelledby": "accountMenuList" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "list-group-item",
                        attrs: { href: _vm.$ceres.urls.myAccount },
                      },
                      [
                        _c("i", { staticClass: "fa fa-user" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.loginMyAccount")
                            )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [{ name: "logout", rawName: "v-logout" }],
                        staticClass: "list-group-item",
                        attrs: { href: "#" },
                      },
                      [
                        _c("i", { staticClass: "fa fa-sign-out" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.loginLogout")
                            )
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c(
          "div",
          [
            _vm.showLogin
              ? _c(
                  "a",
                  {
                    staticClass: "nav-link",
                    attrs: {
                      "data-testing": "login-select",
                      href: _vm.isLogin ? "javascript:void(0)" : "#login",
                      "data-toggle": _vm.isLogin ? false : "modal",
                      "aria-label": _vm.$translate("Ceres::Template.login"),
                    },
                    on: {
                      click: function ($event) {
                        _vm.createLoginModal()
                        _vm.unmarkInputFields()
                      },
                    },
                  },
                  [
                    !_vm.noIcons
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "31.193",
                              height: "31.193",
                              viewBox: "0 0 31.193 31.193",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "data-name": "iconLogin1",
                                d: "M21.6,26.216c8.614,0,15.6,3.258,15.6,7.278v5.2H6v-5.2C6,29.474,12.983,26.216,21.6,26.216Zm13.517,7.278c0-2.87-6.052-5.2-13.517-5.2S8.08,30.625,8.08,33.494v3.119H35.114ZM21.6,7.5a7.278,7.278,0,1,1-7.278,7.278A7.278,7.278,0,0,1,21.6,7.5Zm0,2.08a5.2,5.2,0,1,0,5.2,5.2,5.2,5.2,0,0,0-5.2-5.2Z",
                                transform: "translate(-6 -7.5)",
                                fill: "#fff",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.smallStyle
                      ? _c("span", { staticClass: "d-none d-sm-inline" }, [
                          _vm._v(
                            _vm._s(_vm.$translate("Ceres::Template.login"))
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showRegistration
              ? [
                  !_vm.showLogin
                    ? _c("span", { staticClass: "pipe" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        "data-testing": "register-select",
                        href: _vm.isRegister
                          ? "javascript:void(0)"
                          : "#registration",
                        "data-toggle": _vm.isRegister ? false : "modal",
                        "aria-label": _vm.$translate(
                          "Ceres::Template.loginRegister"
                        ),
                      },
                      on: {
                        click: function ($event) {
                          _vm.createRegisterModal()
                          _vm.unmarkInputFields()
                        },
                      },
                    },
                    [
                      !_vm.noIcons
                        ? _c("i", {
                            staticClass: "fa fa-user-plus mr-1",
                            attrs: { "aria-hidden": "true" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.smallStyle
                        ? _c("span", { staticClass: "d-none d-sm-inline" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate("Ceres::Template.loginRegister")
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }